import { api } from "api/apiHelper";
import { Endpoints } from "api/apiConst";

export const getRevenue = async () => {
  const endpoint = Endpoints.REVENUE;
  return api.get(endpoint).then((response) => response.data);
};
